import { Scores } from './types';

export function updateScoresForQ1(selectedOptions: string[]): Partial<Scores> {
  const scores: Partial<Scores> = {
    score_Original: 0,
    score_MaxPain: 0,
    score_Spray: 0,
    score_Lidocaine: 0,
    score_UltraHemp: 0,
    score_FootTherapy: 0
  };

  selectedOptions.forEach(option => {
    switch (option) {
      case 'Joints (knees, hips, fingers)':
        scores.score_Original! += 2;
        scores.score_MaxPain! += 3;
        scores.score_Spray! += 1;
        scores.score_Lidocaine! += 2;
        scores.score_UltraHemp! += 3;
        scores.score_FootTherapy! += 0;
        break;
      case 'Muscles (back, shoulders, legs)':
        scores.score_Original! += 2;
        scores.score_MaxPain! += 2;
        scores.score_Spray! += 3;
        scores.score_Lidocaine! += 1;
        scores.score_UltraHemp! += 3;
        scores.score_FootTherapy! += 0;
        break;
      case 'Feet (heels, arches, toes)':
        scores.score_Original! += 0;
        scores.score_MaxPain! += 0;
        scores.score_Spray! += 0;
        scores.score_Lidocaine! += 1;
        scores.score_UltraHemp! += 1;
        scores.score_FootTherapy! += 3;
        break;
      case 'Nerve pain (sharp, shooting discomfort)':
        scores.score_Original! += 0;
        scores.score_MaxPain! += 1;
        scores.score_Spray! += 0;
        scores.score_Lidocaine! += 3;
        scores.score_UltraHemp! += 1;
        scores.score_FootTherapy! += 0;
        break;
      case 'General aches & stiffness':
        scores.score_Original! += 3;
        scores.score_MaxPain! += 2;
        scores.score_Spray! += 1;
        scores.score_Lidocaine! += 1;
        scores.score_UltraHemp! += 2;
        scores.score_FootTherapy! += 1;
        break;
    }
  });

  return scores;
}

export function updateScoresForQ2(selected: string): Partial<Scores> {
  switch (selected) {
    case 'Occasional soreness or stiffness':
      return {
        score_Original: 2,
        score_MaxPain: 1,
        score_Spray: 2,
        score_Lidocaine: 0,
        score_UltraHemp: 2,
        score_FootTherapy: 1
      };
    case 'Chronic or persistent discomfort':
      return {
        score_Original: 1,
        score_MaxPain: 3,
        score_Spray: 1,
        score_Lidocaine: 2,
        score_UltraHemp: 2,
        score_FootTherapy: 1
      };
    case 'Sharp, sudden pain':
      return {
        score_Original: 0,
        score_MaxPain: 1,
        score_Spray: 0,
        score_Lidocaine: 3,
        score_UltraHemp: 1,
        score_FootTherapy: 0
      };
    case 'Post-workout or overuse soreness':
      return {
        score_Original: 1,
        score_MaxPain: 1,
        score_Spray: 3,
        score_Lidocaine: 0,
        score_UltraHemp: 2,
        score_FootTherapy: 1
      };
    default:
      return {};
  }
}

export function updateScoresForQ3(selected: string): Partial<Scores> {
  switch (selected) {
    case 'Fast-acting, numbing relief':
      return {
        score_Original: 1,
        score_MaxPain: 1,
        score_Spray: 1,
        score_Lidocaine: 3,
        score_UltraHemp: 1,
        score_FootTherapy: 1
      };
    case 'Long-lasting support for everyday pain':
      return {
        score_Original: 2,
        score_MaxPain: 3,
        score_Spray: 1,
        score_Lidocaine: 1,
        score_UltraHemp: 2,
        score_FootTherapy: 1
      };
    case 'Hands-free, mess-free application':
      return {
        score_Original: 0,
        score_MaxPain: 0,
        score_Spray: 3,
        score_Lidocaine: 1,
        score_UltraHemp: 0,
        score_FootTherapy: 0
      };
    case 'Deep-penetrating moisture for skin & joints':
      return {
        score_Original: 3,
        score_MaxPain: 2,
        score_Spray: 1,
        score_Lidocaine: 1,
        score_UltraHemp: 3,
        score_FootTherapy: 2
      };
    default:
      return {};
  }
}

export function updateScoresForQ4(selected: string): Partial<Scores> {
  switch (selected) {
    case 'Cream that absorbs fast':
      return {
        score_Original: 2,
        score_MaxPain: 2,
        score_Spray: 0,
        score_Lidocaine: 2,
        score_UltraHemp: 2,
        score_FootTherapy: 2
      };
    case 'Spray for hands-free relief':
      return {
        score_Original: 0,
        score_MaxPain: 0,
        score_Spray: 3,
        score_Lidocaine: 0,
        score_UltraHemp: 0,
        score_FootTherapy: 0
      };
    case 'Patch for all-day comfort':
      return {
        score_Original: 0,
        score_MaxPain: 0,
        score_Spray: 0,
        score_Lidocaine: 0,
        score_UltraHemp: 0,
        score_FootTherapy: 0
      };
    default:
      return {};
  }
}

export function getTopTwoProducts(scores: Scores): [keyof Scores, keyof Scores] {
  return Object.entries(scores)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 2)
    .map(([key]) => key as keyof Scores) as [keyof Scores, keyof Scores];
}